export default theme => ({
  input: {
    height: '34px',
    borderColor: theme.colors.threatAssocGray,
  },
  input__threat: {
    width: '360px',
  },
});
